import { Component, OnInit } from '@angular/core';
import { SecurityHelper } from '../../common/securityHelper';
import { ChangePasswordService } from './change-password.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { ToastrService } from 'ngx-toastr';
import { SecurityService } from '../../security/service/security.service';
import { OnlineOfflineService } from '../../../services/online-offline.service';

@Component({
  standalone: false,
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public oldPassword!: string;
  public newPassword!: string;
  public confirmNewPassword!: string;
  public errorMessageList!: string[];
  userName!: string;
  shipId: number = 0;
  crewSubTypeId: number = 0;

  constructor(
    public securityService: SecurityService,
    private changePasswordService: ChangePasswordService,
    private router: Router, private loginServ: LoginService,
    private toasts: ToastrService,
    readonly onlineOfflineService: OnlineOfflineService) {
  }

  ngOnInit() {

    this.oldPassword = '';
    this.newPassword = '';
    this.confirmNewPassword = '';
    this.errorMessageList = [];

    let userData = SecurityHelper.GetLoggedInUserData();
    this.userName = userData.username;
    this.shipId = userData.shipID;
    switch (userData.roleID) {
      case 30: //Cook
        this.crewSubTypeId = 12;
        break;
      case 31: //Captain
        this.crewSubTypeId = 11;
        break;
    }
  }

  changePassword() {

    if (this.validate()) {

      if (!SecurityHelper.GetLoggedInUserData().isPasswordExpired) {

        // call service:
        this.changePasswordService.changePassword(SecurityHelper.GetLoggedInUserData().userID, this.oldPassword, this.newPassword).subscribe(
          (res: any) => {

            if (this.isResponseValid(res)) {

              swal.fire({
                title: 'Successful',
                html: '<span>Your password has been successfully changed.<br>Please log in again to continue.</span>',
                icon: "success",
                showCloseButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false
              })
                .then((result) => {
                  if (result.value) {
                    SecurityHelper.GoBackToLoginPage();
                  }
                });

            }
          });

      }
      else {

        // check if unathorized when calling API using temporary access token
        SecurityHelper.IsHTTPRequestsUnathorized(true);

        // call service:
        this.changePasswordService.changeExpiredPassword(SecurityHelper.GetLoggedInUserData().userID, this.oldPassword, this.newPassword).subscribe(
          (res: any) => {

            if (this.isResponseValid(res)) {

              swal.fire({
                title: 'Successful',
                html: '<span>Your password has been successfully changed.<br>Please log in again to continue.</span>',
                icon: "success",
                showCloseButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false
              })
                .then((result) => {
                  if (result.value) {
                    SecurityHelper.GoBackToLoginPage();
                  }
                });

            }
          });
      }
    }

  }

  goToLogin() {

    if (!SecurityHelper.GetLoggedInUserData().isPasswordExpired && this.onlineOfflineService.isOnline && !SecurityHelper.IsHTTPRequestsUnathorized(true)) {

      this.loginServ.logOut().subscribe(() => {
        SecurityHelper.GoBackToLoginPage();
      });
    }
    else {

      SecurityHelper.GoBackToLoginPage();
    }

  }
  private validate() {
    // reset validation
    this.errorMessageList = [];

    if (!this.oldPassword || this.oldPassword.trim() === '')
      this.errorMessageList.push('Please enter your old password.');

    if (!this.newPassword || this.newPassword.trim() === '')
      this.errorMessageList.push('Please enter your new password.');

    if (this.newPassword.length > 0 && this.newPassword !== this.confirmNewPassword) {
      this.errorMessageList.push('New and Confirm password did not match.');
    }

    return (this.errorMessageList.length === 0);
  }

  // Common

  handleError(error: any) {
    let errorTitle = error.name ? error.name : 'Error';
    let errorMessage = error.message ? error.message : JSON.stringify(error);

    swal.fire({
      title: errorTitle,
      html: '<span>' + errorMessage + '</span>',
      icon: "error",
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  }
  
  isResponseValid(res: any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
      this.handleError(res.errorMessage[0]);
    }

    return isValid;
  }

}
